<template>
  <b-card class="bg-light border-primary p-0" v-if="showModal">
    <b-form class="  p-0" v-if="addressSearchTool">
      <b-form-group
        label=""
        label-for="address-search-query-autocomplete"
        class=""
      >
        <autocomplete
          ref="autocompleteAddress"
          id="address-search-query-autocomplete"
          v-model="autocompleteSelectedItem"
          :items="addressAutocompleteItems"
          @item-selected="addressAutocompleteItemSelected"
          @update-items="addressAutocompleteUpdated"
          :get-label="getAutocompleteLabel"
          :input-attrs="{
            placeholder:
              'Wyszukaj adres (np. Warszawa, Aleja Jana Pawła II 49)',
            class: 'form-control'
          }"
          :min-len="0"
          :auto-select-one-item="false"
          :component-item="autocompleteTemplate"
        >
        </autocomplete>
      </b-form-group>
      <b-form-group class="d-flex justify-content-end m-0">
        <b-btn variant="primary" :disabled="!item" @click="saveGeometry()"
          >Zapisz</b-btn
        >
        <b-btn class="ml-2" variant="outline-secondary" @click="cancel()"
          >Anuluj</b-btn
        >
      </b-form-group>
    </b-form>
  </b-card>
</template>

<script>
import Autocomplete from 'v-autocomplete';
import AutocompleteItem from '../SidebarSearch/AutocompleteItem.vue';
import { mapGetters } from 'vuex';
import {
  SEARCH_ADDRESS_SET_SELECTED_OBJECT,
  SEARCH_LOADER_SHOW,
  SEARCH_LOADER_HIDE
} from '../../store/mutations.type';
import { SEARCH_COORDINATE_FOR_ADDRESS_GET } from '../../store/actions.type';

export default {
  name: 'AdressSearchModal',
  components: {
    Autocomplete,
    AutocompleteItem
  },
  props: {
    showAdressSearchModal: false
  },
  computed: {
    ...mapGetters(['addressSearchTool'])
  },
  watch: {
    showAdressSearchModal: function(newVal) {
      this.showModal = newVal;
    }
  },
  data() {
    return {
      autocompleteSelectedItem: null,
      addressAutocompleteItems: [],
      autocompleteTemplate: AutocompleteItem,
      showModal: false,
      item: null
    };
  },
  methods: {
    async addressAutocompleteUpdated(text) {
      this.$store.commit(SEARCH_LOADER_SHOW);

      var response = await this.$store.dispatch(
        SEARCH_COORDINATE_FOR_ADDRESS_GET,
        { address: text }
      );

      this.addressAutocompleteItems =
        response != null ? Object.values(response) : [];

      this.$store.commit(SEARCH_LOADER_HIDE);
    },
    getAutocompleteLabel(item) {
      if (item && item != null) {
        if (item.street && item.number) {
          return `${item.street} ${item.number}, ${item.city}`;
        } else if (item.street) {
          return `${item.street}, ${item.city}`;
        } else if (item.number) {
          return `${item.city} ${item.number}`;
        } else {
          return `${item.city}, ${item.voivodeship}, ${item.county}, ${item.commune}`;
        }
      }
      return this.$refs.autocompleteAddress.searchText;
    },
    async addressAutocompleteItemSelected(item) {
      this.item = item;
      const itemGeometry = [item.x, item.y];
      this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, itemGeometry);
    },
    cancel() {
      this.setInitVariables();
      this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, {
        x: null,
        y: null
      });
      this.$emit('cancel');

      // this.$tours.myTour.stop();
    },
    setInitVariables() {
      this.autocompleteSelectedItem = null;
      this.addressAutocompleteItems = [];
      this.autocompleteTemplate = AutocompleteItem;
      this.item = null;
    },
    saveGeometry() {
      window.console.log(this.item);
      this.$emit('submitItem', this.item);
      this.cancel();
    }
  }
};
</script>
<style></style>
